import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class OnDemandPreloadingStrategy implements PreloadingStrategy {
  private preloadSignal$ = new Subject<void>();
  private triggered = false;

  /** Call this to begin preloading all lazy-loaded modules. */
  triggerPreload(): void {
    if (!this.triggered) {
      this.triggered = true;
      this.preloadSignal$.next();
      this.preloadSignal$.complete();
    }
  }

  preload(_route: Route, loadFn: () => Observable<any>): Observable<any> {
    if (this.triggered) {
      return loadFn();
    }
    return this.preloadSignal$.pipe(
      take(1),
      mergeMap(() => loadFn())
    );
  }
}
